import HttpError from './HttpError';

export default class InvitationExpiredError extends HttpError {}
